import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
    ReactiveFormsModule,
    FormsModule
} from "@angular/forms";
import { NgxPermissionsModule } from "ngx-permissions";
import { MaterialModule } from "../../../components/material/material.module";
import { OtsComponent } from "./ots.component";
import { OtsRoutingModule } from "./ots-routing.module";
import { BotonToggleModule } from "../../../components/boton/boton-toggle.module";
import { OtModule } from "../../../forms/ot/ot.module";

@NgModule({
    imports: [
        CommonModule,
        OtsRoutingModule,
        ReactiveFormsModule,
        BotonToggleModule,
        FormsModule,
        NgxPermissionsModule.forChild(),
        MaterialModule,
        OtModule,
    ],
    declarations: [
        OtsComponent
    ],
    providers: [
    ]
})
export class OtsModule { }